import { Button } from '@cambridgeassessment/cambridge-ui';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import React from 'react';

type Props = {
  onClick: () => void;
};

const Remove: React.FC<Props> = ({ onClick }) => {
  return (
    <Button
      data-testid="remove"
      color="destructive"
      variant="text"
      onClick={onClick}
      startIcon={<DeleteOutlinedIcon />}
      size="small"
    >
      Remove
    </Button>
  );
};

export default Remove;
